import clsx from 'clsx'
import { useState, type FunctionComponent } from 'react'
import { useIsAllowedToFullUse } from '../../../hooks/useIsAllowedToFullUse'
import type { ScoreResult } from '../../data/ScoreFragment'
import { useAuth } from '../../user/UserContext'
import { Button } from './Button'
import { Collapsible } from './Collapsible'
import { ReviewForm } from './ReviewForm'
import style from './ReviewForm.module.sass'

type ReviewFormWrapperProps = {
	scoreOptions?: ScoreResult[]
	title: string
	buttonLabel: string
	openLoginModal: () => void
	id: string
	setOrder: (value: boolean) => void
}

export const ReviewFormWrapper: FunctionComponent<ReviewFormWrapperProps> = ({
	title,
	buttonLabel,
	scoreOptions,
	openLoginModal,
	id,
	setOrder,
}) => {
	const [isFormVisible, setIsFormVisible] = useState(false)

	const auth = useAuth()
	const isAllowedToFullUse = useIsAllowedToFullUse()
	const user = auth.status === 'signedIn' ? auth.user : null

	if (user?.blockedAt) {
		return null
	}

	return (
		<div className={style.reviewAdd}>
			<h2 className={clsx(style.reviewAddTitle, style.reviewAddTitleNarrow)}>{title}</h2>

			{!isFormVisible && (
				<Button label={buttonLabel} onClick={isAllowedToFullUse ? () => setIsFormVisible(true) : openLoginModal} />
			)}
			<Collapsible open={isFormVisible}>
				<ReviewForm
					key={auth.status}
					scoreOptions={scoreOptions ?? undefined}
					id={id}
					closeForm={() => setIsFormVisible(false)}
					resetOrder={() => setOrder(false)}
					setOrder={() => setOrder(true)}
				/>
			</Collapsible>
		</div>
	)
}
